/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  AgentCrashReport,
  AgentCrashReport$Outbound,
  AgentCrashReport$outboundSchema,
} from "./agentcrashreport.js";

export type ReportCrashRequestBody = {
  /**
   * Queued crash reports, oldest first.
   */
  reports: Array<AgentCrashReport>;
};

/** @internal */
export type ReportCrashRequestBody$Outbound = {
  reports: Array<AgentCrashReport$Outbound>;
};

/** @internal */
export const ReportCrashRequestBody$outboundSchema: z.ZodMiniType<
  ReportCrashRequestBody$Outbound,
  ReportCrashRequestBody
> = z.object({
  reports: z.array(AgentCrashReport$outboundSchema),
});

export function reportCrashRequestBodyToJSON(
  reportCrashRequestBody: ReportCrashRequestBody,
): string {
  return JSON.stringify(
    ReportCrashRequestBody$outboundSchema.parse(reportCrashRequestBody),
  );
}
